export default __webpack_public_path__ + "static/media/map-pin-orange.5d59c10c.svg";